import buildQueryString from 'coact/utils/api/buildQueryString'

const printExcel = spec => {
  const { doc, filename, template } = spec
  const queryStirng = buildQueryString({ id: doc._id, fullname: filename })
  const url = `/api/print/${template}/xlsx?${queryStirng}`
  window.open(url)
}

export default printExcel
